import { apiUrl, fetchJson } from '../../apiBase';

const basePath = (schoolId, studentId) => {
  const school = encodeURIComponent(schoolId || '');
  const student = encodeURIComponent(studentId || '');
  return apiUrl(`/admin/observation-journal/${school}/students/${student}`);
};

const schemaPath = (schoolId, studentId) => `${basePath(schoolId, studentId)}/schema`;

const entryPath = (schoolId, entryId) => {
  const school = encodeURIComponent(schoolId || '');
  const entry = encodeURIComponent(entryId || '');
  return apiUrl(`/admin/observation-journal/${school}/entries/${entry}`);
};

export async function listObservationEntries(schoolId, studentId) {
  if (!schoolId || !studentId) return [];
  const res = await fetchJson(basePath(schoolId, studentId));
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Gözlem kayıtları alınamadı');
  }
  return res.json();
}

export async function getObservationSchema(schoolId, studentId) {
  if (!schoolId || !studentId) throw new Error('Öğrenci seçilmedi');
  const res = await fetchJson(schemaPath(schoolId, studentId));
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Gözlem şeması alınamadı');
  }
  return res.json();
}

export async function createObservationEntry(schoolId, studentId, payload) {
  if (!schoolId || !studentId) throw new Error('Öğrenci seçilmedi');
  const body = typeof payload === 'string' ? { review_text: payload } : payload;
  const res = await fetchJson(basePath(schoolId, studentId), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Gözlem kaydedilemedi');
  }
  return res.json();
}

export async function updateObservationEntry(schoolId, entryId, payload) {
  if (!schoolId || !entryId) throw new Error('Kayıt bulunamadı');
  const body = typeof payload === 'string' ? { review_text: payload } : payload;
  const res = await fetchJson(entryPath(schoolId, entryId), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Gözlem güncellenemedi');
  }
  return res.json();
}

export async function deleteObservationEntry(schoolId, entryId) {
  if (!schoolId || !entryId) throw new Error('Kayıt bulunamadı');
  const res = await fetchJson(entryPath(schoolId, entryId), { method: 'DELETE' });
  if (!res.ok && res.status !== 204) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Gözlem silinemedi');
  }
}

export async function sendObservationEntry(schoolId, entryId) {
  if (!schoolId || !entryId) throw new Error('Kayıt bulunamadı');
  const res = await fetchJson(`${entryPath(schoolId, entryId)}/send`, { method: 'POST' });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'WhatsApp gönderimi başarısız');
  }
  return res.json();
}

export async function getObservationSummary(schoolId, classId) {
  if (!schoolId || !classId) {
    throw new Error('Şube seçilmelidir');
  }
  const params = new URLSearchParams({ class_id: String(classId) });
  const url = `${apiUrl(`/admin/observation-summary/${encodeURIComponent(schoolId)}`)}?${params.toString()}`;
  const res = await fetchJson(url);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    const message = text || (res.status === 403 ? 'Bu şube için yetkiniz yok' : 'Gözlem özeti alınamadı');
    throw new Error(message);
  }
  return res.json();
}
